import { type Entry, createClient } from "contentful";

import { CONTENTFUL_ACCESS_TOKEN, CONTENTFUL_SPACE_ID } from "~/env";

import { type UseQueryOptions, type UseQueryResult, useQuery } from "../react-query";

const contentfulClient = createClient({
	space: CONTENTFUL_SPACE_ID,
	accessToken: CONTENTFUL_ACCESS_TOKEN,
});

export const createUseQueryEntry =
	<TValue>(entryId: string) =>
	<TResult = Entry<TValue>>(
		options?: UseQueryOptions<Entry<TValue>, Error, TResult>,
	): UseQueryResult<TResult, Error> => {
		return useQuery(["contentful", "entry", entryId], () => contentfulClient.getEntry(entryId), {
			// never stale the data
			staleTime: Number.POSITIVE_INFINITY,
			refetchOnMount: false,
			refetchOnWindowFocus: false,
			...options,
		});
	};
